import { createAction, createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const NotificationModel = ({
    id,
    type,
    header,
    message
}) => ({
    id: id || uuidv4(),
    type,
    header,
    message,
})

const createPayload = (extraProps) => (notification) => ({
    payload: {
        ...NotificationModel(notification),
        ...extraProps,
    }
})

export const errorNotification = createAction(
    "notifications/showNotification",
    createPayload({ type: "error" })
)

export const successNotification = createAction(
    "notifications/showNotification",
    createPayload({ type: "success" })
);

export const notificationsSlice = createSlice({
    name: "notifications",
    initialState: [],
    reducers: {
        showNotification: (notifications, { payload: notification }) => [
            ...notifications,
            notification
        ],
        removeNotification: (notifications, { payload: idToRemove }) =>
            notifications.filter(({ id }) => id !== idToRemove),
    },
});

export default notificationsSlice.reducer;

export const {
    showNotification,
    removeNotification,
} = notificationsSlice.actions;